import { LocalStorage } from "./LocalStorage";
import { PerformanceMonitorStorageSerializer } from "./PerformanceMonitorStorageSerializer";
import { StorageManager } from "./StorageManager";
export class PerformanceMonitorStorageManager {
    constructor() { }
    static getInstance() {
        if (PerformanceMonitorStorageManager.instance === undefined) {
            PerformanceMonitorStorageManager.instance = new StorageManager({
                storage: LocalStorage.create(),
                storageKey: "client_performanceMonitor",
                storageSerializer: new PerformanceMonitorStorageSerializer(),
            });
        }
        return PerformanceMonitorStorageManager.instance;
    }
    static restore() {
        return PerformanceMonitorStorageManager.getInstance().restore();
    }
    static store(toStore) {
        return PerformanceMonitorStorageManager.getInstance().store(toStore);
    }
}
